﻿(function(){
  function enhanceSelects(context){
    var root = context || document;
    // Scope to this block only
    var blocks = root.querySelectorAll('.ws-block--contact-form, .bpc-sidebar-contact-form-wrapper');
    if (!blocks.length) {
      // Fallback: enhance CF7 forms anywhere if block class not found
      blocks = [root];
    }

    blocks.forEach(function(block){
      var selects = block.querySelectorAll('.wpcf7-form select, form select');
      selects.forEach(function(select){
        if (select.dataset.wsEnhanced) {  
          try { select.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
          return;
        }

        // Build wrapper
        var wrapper = document.createElement('div');
        wrapper.className = 'ws-select';
        var display = document.createElement('div');
        display.className = 'ws-select__display';
        var arrow = document.createElement('span');
        arrow.className = 'ws-select__arrow';
        var menu = document.createElement('div');
        menu.className = 'ws-select__menu';

        // Insert wrapper around select
        var parent = select.parentNode;
        parent.insertBefore(wrapper, select);
        wrapper.appendChild(select);
        wrapper.appendChild(display);
        wrapper.appendChild(arrow);
        wrapper.appendChild(menu);

        // Fallback inline styles to guarantee look even if CSS isn't built yet
        try {
          wrapper.style.position = wrapper.style.position || 'relative';
          wrapper.style.display = wrapper.style.display || 'block';
          select.style.cssText += 'appearance:none;-webkit-appearance:none;-moz-appearance:none;background-image:none;color:transparent;-webkit-text-fill-color:transparent;text-shadow:0 0 0 transparent;padding-right:4rem;position:relative;z-index:1;pointer-events:none;';
          select.tabIndex = -1;
          display.style.cssText += 'position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;display:flex;align-items:center;gap:0.6rem;padding:2rem 0;line-height:1.1;letter-spacing:-0.01em;z-index:3;';
          arrow.style.cssText += 'position:absolute;right:0;top:50%;transform:translateY(-50%);width:1.6rem;height:1.6rem;background-repeat:no-repeat;background-size:1.6rem 1.6rem;background-position:center;pointer-events:none;z-index:3;';
          // Always use white asset; SCSS will recolor via filter in light theme
          var svgData = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.76001 1.75977L14.28 14.2798" stroke="white" stroke-width="2" stroke-miterlimit="10"/><path d="M14.2805 1.47998V14.28H1.48047" stroke="white" stroke-width="2" stroke-miterlimit="10"/></svg>';
          var dataUrl = 'url("data:image/svg+xml;utf8,' + encodeURIComponent(svgData) + '")';
          arrow.style.backgroundImage = dataUrl;
        } catch (e) {}

        // ARIA roles for better accessibility
        try {
          wrapper.setAttribute('role', 'combobox');
          wrapper.setAttribute('aria-haspopup', 'listbox');
          wrapper.setAttribute('aria-expanded', 'false');
          var menuId = 'ws-select-menu-' + Math.random().toString(36).slice(2);
          menu.id = menuId;
          wrapper.setAttribute('aria-controls', menuId);
          menu.setAttribute('role', 'listbox');
          wrapper.tabIndex = 0;
        } catch (e) {}

        function buildMenu(){
          menu.innerHTML = '';
          for (var i = 1; i < select.options.length; i++) {
            var opt = select.options[i];
            var optionEl = document.createElement('div');
            optionEl.className = 'ws-select__option';
            optionEl.setAttribute('role', 'option');
            optionEl.setAttribute('data-value', opt.value);
            optionEl.textContent = opt.textContent || opt.label || opt.value;
            var isSelected = select.value === opt.value;
            if (isSelected) {
              optionEl.classList.add('is-selected');
              optionEl.setAttribute('aria-selected', 'true');
            } else {
              optionEl.setAttribute('aria-selected', 'false');
            }
            optionEl.addEventListener('click', function(e){
              var val = e.currentTarget.getAttribute('data-value');
              if (val !== null) {
                select.value = val;
                try { select.dispatchEvent(new Event('change', {bubbles:true})); } catch (_e) {
                  var evt = document.createEvent('HTMLEvents');
                  evt.initEvent('change', true, false);
                  select.dispatchEvent(evt);
                }
              }
              closeMenu();
            });
            menu.appendChild(optionEl);
          }
        }

        function openMenu(){
          if (wrapper.classList.contains('is-open')) return;
          wrapper.classList.add('is-open');
          wrapper.setAttribute('aria-expanded', 'true');
          try { if (window.wsLocoUpdate) window.wsLocoUpdate(); } catch (e) {}
        }
        function closeMenu(){
          if (!wrapper.classList.contains('is-open')) return;
          wrapper.classList.remove('is-open');
          wrapper.setAttribute('aria-expanded', 'false');
          try { if (window.wsLocoUpdate) window.wsLocoUpdate(); } catch (e) {}
        }

        function getLabelOption(){
          // Label is first option
          return select.options && select.options.length ? select.options[0] : null;
        }

        function getSelectedOption(){
          return select.options[select.selectedIndex] || null;
        }

        function updateDisplay(){
          var labelOpt = getLabelOption();
          var selectedOpt = getSelectedOption();
          var labelText = labelOpt ? (labelOpt.textContent || labelOpt.label || '') : '';
          var valueText = '';
          var isOnLabel = false;

          if (selectedOpt) {
            // Consider it label if selected index is 0 or value is empty
            isOnLabel = (select.selectedIndex === 0) || (selectedOpt.value === '');
            if (!isOnLabel) {
              valueText = selectedOpt.textContent || selectedOpt.label || '';
            }
          }

          // Render as: LABEL [VALUE]
          // LABEL should be grayed via CSS
          var html = '';
          if (labelText) {
            var isReq = select.required || select.getAttribute('aria-required') === 'true' || select.classList.contains('wpcf7-validates-as-required');
            html += '<span class="ws-select__label">' + escapeHtml(labelText) + (isReq ? ' <span class="ws-required" aria-hidden="true">*</span>' : '') + '</span>';
          }
          if (!isOnLabel && valueText) {
            html += ' <span class="ws-select__value">' + escapeHtml(valueText) + '</span>';
            wrapper.classList.remove('is-placeholder');
          } else {
            wrapper.classList.add('is-placeholder');
          }
          display.innerHTML = html;

          // invalid state based on aria-invalid (CF7)
          var isInvalid = select.getAttribute('aria-invalid') === 'true';
          wrapper.classList.toggle('is-invalid', !!isInvalid);
        }

        function escapeHtml(str){
          return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
        }

        select.addEventListener('change', updateDisplay);
        select.addEventListener('input', updateDisplay);
        // Interactions on wrapper (we disabled native select pointer events)
        wrapper.addEventListener('focus', function(){ wrapper.classList.add('is-focused'); });
        wrapper.addEventListener('blur', function(){ wrapper.classList.remove('is-focused'); });
        wrapper.addEventListener('click', function(e){
          // Option clicks are handled by the option's own listener
          if (e.target.closest && e.target.closest('.ws-select__option')) return;
          // Don't toggle when clicking inside the dropdown menu area (e.g. empty space between options)
          if (e.target.closest && e.target.closest('.ws-select__menu')) return;
          if (wrapper.classList.contains('is-open')) closeMenu(); else openMenu();
        });
        wrapper.addEventListener('keydown', function(e){
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (wrapper.classList.contains('is-open')) closeMenu(); else openMenu();
          } else if (e.key === 'Escape') {
            closeMenu();
          } else if (e.key === 'ArrowDown' && !wrapper.classList.contains('is-open')) {
            e.preventDefault();
            openMenu();
          }
        });
        // click outside to close
        function onDocClick(ev){ if (!wrapper.contains(ev.target)) closeMenu(); }
        document.addEventListener('click', onDocClick);
        // Initialize
        select.dataset.wsEnhanced = '1';
        buildMenu();
        updateDisplay();
      });

      // Overlay placeholders for required inputs/textareas to color only the star
      function enhanceRequiredPlaceholders(root){
        var selector = [
          'input[type="text"]',
          'input[type="email"]',
          'input[type="tel"]',
          'input[type="number"]',
          'input[type="date"]',
          'input[type="time"]',
          'input[type="url"]',
          'textarea'
        ].join(',');
        var fields = root.querySelectorAll(selector);
        fields.forEach(function(field){
          var isReq = field.required || field.getAttribute('aria-required') === 'true' || field.classList.contains('wpcf7-validates-as-required');
          var ph = field.getAttribute('placeholder');
          if (!isReq || !ph) return;
          if (field.dataset.wsInputEnhanced) return;

          var wrap = document.createElement('div');
          wrap.className = 'ws-input';
          var overlay = document.createElement('div');
          overlay.className = 'ws-input__placeholder';
          overlay.innerHTML = '<span class="label"></span> <span class="ws-required" aria-hidden="true">*</span>';
          overlay.querySelector('.label').textContent = ph;

          var parent = field.parentNode;
          parent.insertBefore(wrap, field);
          wrap.appendChild(field);
          wrap.appendChild(overlay);

          function sync(){
            if (field.value && String(field.value).length > 0) {
              wrap.classList.add('has-value');
            } else {
              wrap.classList.remove('has-value');
            }
          }
          field.addEventListener('input', sync);
          field.addEventListener('change', sync);
          field.addEventListener('focus', function(){ wrap.classList.add('is-focused'); sync(); });
          field.addEventListener('blur', function(){ wrap.classList.remove('is-focused'); sync(); });
          // initialize
          field.dataset.wsInputEnhanced = '1';
          // keep native placeholder (hidden via CSS) for accessibility
          sync();
        });
      }
      enhanceRequiredPlaceholders(block);

      // Enhance CF7 file inputs
      var fileInputs = block.querySelectorAll('.wpcf7-form input[type="file"], form input[type="file"]');
      fileInputs.forEach(function(input){
        if (input.dataset.wsEnhanced) {
          return;
        }

        var wrap = document.createElement('div');
        wrap.className = 'ws-file';
        var indicator = document.createElement('div');
        indicator.className = 'ws-file__indicator';
        indicator.textContent = '+';
        var filenameEl = document.createElement('div');
        filenameEl.className = 'ws-file__filename';
        var filenameText = document.createElement('span');
        filenameText.className = 'ws-file__name';
        var removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'ws-file__remove';
        removeBtn.setAttribute('aria-label', 'Remove file');
        removeBtn.textContent = '×';
        filenameEl.appendChild(filenameText);
        filenameEl.appendChild(removeBtn);

        var parent = input.parentNode;
        parent.insertBefore(wrap, input);
        wrap.appendChild(input);
        wrap.appendChild(indicator);
        wrap.appendChild(filenameEl);

        // Fallback inline styles if CSS isn't built
        try {
          wrap.style.position = wrap.style.position || 'relative';
          wrap.style.display = wrap.style.display || 'flex';
          wrap.style.alignItems = wrap.style.alignItems || 'center';
          wrap.style.justifyContent = wrap.style.justifyContent || 'center';
          wrap.style.border = wrap.style.border || '1px solid var(--color-text)';
          wrap.style.borderRadius = wrap.style.borderRadius || '10rem';
          wrap.style.cursor = wrap.style.cursor || 'pointer';
          indicator.style.fontSize = indicator.style.fontSize || '4rem';
          indicator.style.lineHeight = indicator.style.lineHeight || '1';
          indicator.style.color = indicator.style.color || 'var(--color-text)';
          indicator.style.userSelect = 'none';
          filenameEl.style.display = 'none';
          filenameEl.style.fontSize = '1.4rem';
          filenameEl.style.textTransform = 'uppercase';
          filenameEl.style.color = 'var(--color-text)';
          input.style.position = 'absolute';
          input.style.inset = '0';
          input.style.opacity = '0';
          input.style.pointerEvents = 'none';
          input.tabIndex = -1;
        } catch (e) {}

        // Keyboard focus/activation
        wrap.tabIndex = 0;

        function updateFilename(){
          var files = input.files;
          if (files && files.length) {
            var name = files[0].name || '';
            filenameText.textContent = name;
            filenameEl.style.display = 'flex';
            indicator.style.display = 'none';
            wrap.classList.add('has-file');
          } else {
            filenameText.textContent = '';
            filenameEl.style.display = 'none';
            indicator.style.display = 'block';
            wrap.classList.remove('has-file');
          }
        }

        // Open dialog only once via wrapper
        function openDialog(){ try { input.click(); } catch (e) {} }
        wrap.addEventListener('click', function(e){
          if (e.target === removeBtn) return; // removing handled separately
          openDialog();
        });
        wrap.addEventListener('keydown', function(e){
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openDialog(); }
        });
        wrap.addEventListener('focus', function(){ wrap.classList.add('is-focused'); });
        wrap.addEventListener('blur', function(){ wrap.classList.remove('is-focused'); });
        input.addEventListener('change', updateFilename);

        // Remove/clear selection
        removeBtn.addEventListener('click', function(e){
          e.stopPropagation();
          try {
            input.value = '';
            if (typeof DataTransfer !== 'undefined') {
              var dt = new DataTransfer();
              input.files = dt.files;
            }
          } catch (err) {}
          try { input.dispatchEvent(new Event('change', {bubbles:true})); } catch (_e) {
            var evt = document.createEvent('HTMLEvents');
            evt.initEvent('change', true, false);
            input.dispatchEvent(evt);
          }
          updateFilename();
        });

        // invalid state from CF7
        var invalid = input.getAttribute('aria-invalid') === 'true';
        wrap.classList.toggle('is-invalid', !!invalid);

        input.dataset.wsEnhanced = '1';
        updateFilename();
      });  

      // Observe DOM changes (CF7 may rerender on validation)
      // NOTE: this can be expensive inside the WordPress editor,
      // so only attach a single observer per block and skip it entirely in wp-admin.
      var isWpAdmin = false;
      try {
        isWpAdmin = !!(document.body && document.body.classList.contains('wp-admin'));
      } catch (e) {}

      if (!isWpAdmin && block.dataset && !block.dataset.wsObserverAttached) {
        block.dataset.wsObserverAttached = '1';
        try {
          var observer = new MutationObserver(function(mutations){ 
            var needsEnhance = false;
            var needsMark = false;
            mutations.forEach(function(m){
              if (m.addedNodes && m.addedNodes.length) {
                m.addedNodes.forEach(function(n){
                  if (n.nodeType === 1 && (
                    n.matches('select,input[type="file"],input,textarea') ||
                    (n.querySelector && (n.querySelector('select') || n.querySelector('input[type="file"]') || n.querySelector('input') || n.querySelector('textarea')))
                  )) {
                    needsEnhance = true;
                    needsMark = true;
                  }
                });
              }
            });
            if (needsEnhance) enhanceSelects(block);
            if (needsMark) enhanceRequiredPlaceholders(block);
          });
          observer.observe(block, { childList: true, subtree: true });
        } catch (e) {}
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function(){ enhanceSelects(document); });

  // Recalculate after form reset / CF7 lifecycle
  document.addEventListener('reset', function(e){
    var form = e.target;
    if (form && form.closest && form.closest('.ws-block--contact-form, .bpc-sidebar-contact-form-wrapper')) {
      enhanceSelects(form);
    }
  });

  document.addEventListener('wpcf7mailsent', function(e){
    var form = e.target;
    if (form && form.closest && form.closest('.ws-block--contact-form, .bpc-sidebar-contact-form-wrapper')) {
      enhanceSelects(form);
    }
  });

  // CF7 init (fires on DOM ready and re-init)
  document.addEventListener('wpcf7init', function(e){
    var form = e.target;
    if (form && form.closest && form.closest('.ws-block--contact-form, .bpc-sidebar-contact-form-wrapper')) {
      enhanceSelects(form);
    }
  });

  // CF7 validation events
  document.addEventListener('wpcf7invalid', function(e){
    var form = e.target;
    if (!form || !form.querySelectorAll) return;
    form.querySelectorAll('select[aria-invalid="true"]').forEach(function(select){
      var wrap = select.closest('.ws-select');
      if (wrap) wrap.classList.add('is-invalid');
    });
  });

  if (window.acf && typeof window.acf.addAction === 'function') {
    window.acf.addAction('render_block_preview', function(block){
      enhanceSelects(block && (block[0] || block));
    });
    window.acf.addAction('ready', function(){ enhanceSelects(document); });
  }
})();



